import Catalyst from '@Services/Catalyst';
import { getProjectRouteLevelContent, getStepLevelContent } from '@Pages/RetroSynthesis/ProjectRoute/analytics';

export const onOptionClick = ({ projectId, routeId, stepNumber, routeType, projectInfo }) => {
  Catalyst.trackEvent('contentInteraction', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    action: {
      name: 'rx2:retrosynthesis:option',
    },
  });
};

export const onAddStepClick = ({ projectId, routeId, stepNumber, routeType, projectInfo }) => {
  Catalyst.trackEvent('contentInteraction', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    action: {
      name: 'rx2:retrosynthesis:option:Add reaction',
    },
  });
};

export const onStepDeleteClick = ({ projectId, routeId, stepNumber, routeType, projectInfo }) => {
  Catalyst.trackEvent('contentInteraction', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    action: {
      name: 'rx2:retrosynthesis:option:Delete step start',
    },
  });
};

export const onStepDeleteConfirm = ({ projectId, routeId, stepNumber, routeType, projectInfo }) => {
  Catalyst.trackEvent('contentInteraction', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    action: {
      name: 'rx2:retrosynthesis:option:Delete step success',
    },
  });
};

export const onCopyReaction = ({ projectId, routeId, stepNumber, routeType, projectInfo }) => {
  Catalyst.trackEvent('contentInteraction', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    action: {
      name: 'rx2:retrosynthesis:option:Copy reaction',
    },
  });
};
